module.exports = __webpack_public_path__ + "static/media/icon_user_profile.5872aa91.svg";